<template lang='pug'>
  b-nav-item-dropdown(right='', no-caret='')
    template(slot='button-content')
      i.icon-envelope-letter
      b-badge(pill='', variant='info') {{itemsCount}}
    .dropdown-menu-lg
      b-dropdown-header.text-center(tag='div')
        strong You have {{itemsCount}} messages
      b-dropdown-item
        .message
          .py-3.mr-3.float-left
            .avatar
              img.img-avatar(src='static/img/avatars/7.jpg', alt='admin@bootstrapmaster.com')
              b-badge.avatar-status(variant='success')
          div
            small.text-muted John Doe
            small.text-muted.float-right.mt-1 Just now
          .text-truncate.font-weight-bold
            span.fa.fa-exclamation.text-danger
            |  Important message
          .small.text-muted.text-truncate
            | Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...
      b-dropdown-item(href='#')
        .message
          .py-3.mr-3.float-left
            .avatar
              img.img-avatar(src='static/img/avatars/6.jpg', alt='admin@bootstrapmaster.com')
              b-badge.avatar-status(variant='warning')
          div
            small.text-muted Jane Doe
            small.text-muted.float-right.mt-1 5 minutes ago
          .text-truncate.font-weight-bold Lorem ipsum dolor sit amet
          .small.text-muted.text-truncate
            | Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...
      b-dropdown-item(href='#')
        .message
          .py-3.mr-3.float-left
            .avatar
              img.img-avatar(src='static/img/avatars/5.jpg', alt='admin@bootstrapmaster.com')
              b-badge.avatar-status(variant='danger')
          div
            small.text-muted Janet Doe
            small.text-muted.float-right.mt-1 1:52 PM
          .text-truncate.font-weight-bold Lorem ipsum dolor sit amet
          .small.text-muted.text-truncate
            | Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...
      b-dropdown-item(href='#')
        .message
          .py-3.mr-3.float-left
            .avatar
              img.img-avatar(src='static/img/avatars/4.jpg', alt='admin@bootstrapmaster.com')
              b-badge.avatar-status(variant='info')
          div
            small.text-muted Joe Doe
            small.text-muted.float-right.mt-1 4:03 AM
          .text-truncate.font-weight-bold Lorem ipsum dolor sit amet
          .small.text-muted.text-truncate
            | Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...
      b-dropdown-item.text-center(href='#')
        strong View all messages
</template>
<script>
  export default {
    name: 'header-dropdown-mssgs',
    data: () => {
      return { itemsCount: 7 }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownMssgs.vue